<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h5>RENCANA</h5>
        </div>
      </b-col>
      <!-- <b-col cols="12">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <b-button-group class="add-button-group">
              <b-btn variant="primary" to="/sekolah/create"><font-awesome-icon icon="plus" /> Tambah Data</b-btn>
            </b-button-group>
        </div>
      </b-col> -->
      <b-col cols="12" class="mb-3">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-school_name"
                type="text"
                v-model="filter.school_name"
                placeholder=""
                :need-label="true"
                label="Nama Sekolah"
                id="filter-school_name"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-npsn"
                type="text"
                v-model="filter.npsn"
                placeholder=""
                :need-label="true"
                label="NPSN"
                id="filter-npsn"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-district"
                type="enum"
                :options="list.district"
                v-model="filter.district_id"
                placeholder=""
                :need-label="true"
                label="Kecamatan"
                id="filter-district"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-village_id"
                type="enum"
                :options="list.village"
                v-model="filter.village_id"
                placeholder=""
                :need-label="true"
                label="Desa / Kelurahan"
                id="filter-village_id"
              />
            </b-col>
            <b-col cols="6" md="4">
              <form-group-input
                ref="filter-year-period"
                type="enum"
                :clearable="false"
                :options="list.year_periods"
                v-model="filter.year_period"
                placeholder=""
                :need-label="true"
                label="Tahun"
                id="filter-year-period"
              />
            </b-col>
            <b-col cols="6" md="2">
              <label class="form-label">&nbsp;</label><br />
              <b-btn type="submit" class="btn-in-form" variant="primary">
                <font-awesome-icon icon="search" /><span>Cari</span>
              </b-btn>
              <b-btn
                type="button"
                @click.prevent="clearForm"
                variant="secondary"
                class="btn-in-form ml-2"
              >
                <font-awesome-icon icon="broom" /><span>Clear</span>
              </b-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table
      ref="dataTable"
      :no-actions="true"
      :need-select="false"
      :delete-reason="false"
      :can-delete="false"
      :can-show="false"
      :can-edit="false"
      :data-url="apiUrl.school"
      :data-columns="columns"
      :dataParams="dataParams"
      :defaultDataParams="this.filter"
    >
      <template slot="content_school_name" slot-scope="defaultSlotScope">
          <a :href="'/rencana?year_period=' + filter.year_period + '&school_id=' + defaultSlotScope.colData.id +'&school_name=' + encodeURI(defaultSlotScope.colData.school_name)" target="_blank" style="text-transform: capitalize">{{
              defaultSlotScope.colData.school_name
          }}</a>
      </template>
      <template slot="content_district" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
              defaultSlotScope.colData.district.name
          }}</span>
      </template>
      <template slot="content_jumlah_rkas" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
              parseInt(defaultSlotScope.colData.purchase_disetujui) +
              parseInt(defaultSlotScope.colData.purchase_posting) +
              parseInt(defaultSlotScope.colData.purchase_selesai) +
              parseInt(defaultSlotScope.colData.purchase_verifikasi)
          }}</span>
      </template>
      <template slot="content_purchase_disetujui" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
              parseInt(defaultSlotScope.colData.purchase_disetujui) +
              parseInt(defaultSlotScope.colData.purchase_posting) +
              parseInt(defaultSlotScope.colData.purchase_selesai)
          }}</span>
      </template>
      <template slot="content_purchase_belum_disetujui" slot-scope="defaultSlotScope">
          <span style="text-transform: capitalize">{{
              parseInt(defaultSlotScope.colData.purchase_draft) +
              parseInt(defaultSlotScope.colData.purchase_revisi) +
              parseInt(defaultSlotScope.colData.purchase_verifikasi)
          }}</span>
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
import { objectToOptions, classicObjectToOptions } from "@/_helpers";
import paginatedTable from "@/components/PaginatedTable.vue";
import formGroupInput from "@/components/FormGroupInput.vue";
import RKas from "@/models/Rkas";
import School from "@/models/School";
import District from "@/models/District.js";
import City from "@/models/City.js";
import Village from "@/models/Village.js";

const rkasModel = new RKas();
const schoolModel = new School();
const districtModel = new District();
const cityModel = new City();
const villageModel = new Village();

export default {
  components: {
    formGroupInput,
    paginatedTable,
  },
  data() {
    return {
      isLoading: false,
      current_year: new Date().getFullYear(),
      totalPromiseAreaCount: 0,
      apiUrl: {
        school: schoolModel.endpoint,
      },
      columns: [
        {
          prop: "school_name",
          label: "Nama Sekolah",
          sortable: true,
          resizable: true,  
          minWidth: 200,
        },
        {
          prop: "district",
          label: "Kecamatan",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "npsn",
          label: "NPSN",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "kepsek",
          label: "Kepala Sekolah",
          sortable: true,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "jumlah_rkas",
          label: "Jumlah RKAS",
          sortable: false,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "purchase_disetujui",
          label: "Disetujui",
          sortable: false,
          resizable: true,
          minWidth: 200,
        },
        {
          prop: "purchase_belum_disetujui",
          label: "Belum Disetujui",
          sortable: false,
          resizable: true,
          minWidth: 200,
        },
      ],
      list: {
        city: [],
        district: [],
        village: [],
        year_periods: [],
      },
      filter: {
        year_period: typeof this.$route.query.year_period !== 'undefined' ? this.$route.query.year_period : new Date().getFullYear(),
        school_name: this.$route.query.name ?? null,
        npsn: this.$route.query.npsn ?? null,
        village_id: this.$route.query.village_id ?? null,
        district_id: this.$route.query.district_id ?? null,
        // city_id: this.$route.query.city_id ?? null,
        school_name: this.$route.query.name ?? null,
        school_name: this.$route.query.name ?? null,
        city_id: "950b9f62-d1c6-476b-a12d-9233fe332a75",
        with_stats: "1"
      },
      dataParams: [
        "city_id",
        "district_id",
        "village_id",
        "school_name",
        "npsn",
        "kepsek",
        "with_stats",
        "year_period",
      ],
    };
  },
  // beforeMount() {
  //   this.$router.push({ query: { ...this.$route.query, ...{ city_id: "950b9f62-d1c6-476b-a12d-9233fe332a75", with_stats: "1" } } }).catch((err) => {});
  // },
  watch: {
    "filter.district_id": async function (val, oldVal) {
      if (val) {
        this.list.village = objectToOptions(
          await this.getVillages(val)
        );
        this.filter.village_id = null;
      } else {
        this.filter.district_id = null;
      }
    },
  },
  async mounted() {
    // this.filter.year_period = this.current_year
    
    if (typeof this.$route.query.city_id !== "undefined") {
      this.list.district = objectToOptions(
        await this.getDistricts(this.$route.query.city_id)
      );
    }
    if (typeof this.$route.query.district_id !== "undefined") {
      this.list.village = objectToOptions(
        await this.getVillages(this.$route.query.district_id)
      );
    }

    this.getCities();
    this.getYearPeriod();
  },
  methods: {
    getYearPeriod() {
      const year_start = 2023
      const year = this.current_year

      const years = {};
      for (let i = year_start; i <= year; i++) {
        years[i] = i
      }

      this.list.year_periods = objectToOptions(years)
    },
    getCities() {
      cityModel
        .list({
          name: "labuhan",
          province_id: "950b9d3a-c996-4207-97e7-5a2858981979",
          limit: 10000,
        })
        .then((resp) => {
          let data = [];
          // data[null] = 'Tidak Ada'
          resp.data.forEach((d) => {
            data[d.id] = d.name;
          });
          this.list.city = objectToOptions(data);
        });
    },
    async getDistricts(cityId) {
      return new Promise((resolve) => {
        districtModel
          .list({
            city_id: cityId,
          })
          .then((resp) => {
            let data = [];
            // data[null] = 'Tidak Ada'
            resp.data.forEach((d) => {
              data[d.id] = d.name;
            });
            resolve(data);
            // this.userModel.district_id.options = data
          });
      });
    },
    async getVillages(districtId) {
      return new Promise((resolve) => {
        villageModel
          .list({
            district_id: districtId,
          })
          .then((resp) => {
            let data = [];
            // data[null] = 'Tidak Ada'
            resp.data.forEach((d) => {
              data[d.id] = d.name;
            });
            resolve(data);
            // this.userModel.village_id.options = data
          });
      });
    },
    clearForm() {
      this.$nextTick(() => {
        this.filter = {
          roles: "petugas-tps,verifikator",
          with_user_detail: 1,
          with_user_work_area: 1,
          name: null,
          dapil_id: null,
          tps: null,
          work_area_city_id: null,
          work_area_district_id: null,
          work_area_village_id: null,
        };
        setTimeout(() => {
          this.doFilter();
        }, 100);
      });
    },
    doFilter() {
      this.$refs.dataTable.doFilter(this.filter);
    },
  },
};
</script>